import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RatingService} from "../../services/rating.service";

@Component({
  selector: 'jhi-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnInit{
  @Input() maxStars: number = 5;
  @Output() ratingSelected: EventEmitter<number> = new EventEmitter<number>();

  constructor(public ratingService: RatingService) {
  }

  ngOnInit(): void {
    this.ratingService.starsArray = Array(this.maxStars).fill(0);
  }

  selectRating(rating: number): void {
    this.ratingService.selectedRating = rating;
    this.ratingSelected.emit(rating);
  }
}
